// extracted by mini-css-extract-plugin
export default {"mypage_subsc_edit_form":"form_mypage_subsc_edit_form__FEP6g","mypage_subsc_address_submit":"form_mypage_subsc_address_submit__Ejais"};